import React, { useState, useEffect } from 'react';
import cbRedIcon from "../../assets/icons/pooling/cb-red.svg";
import cbGreenIcon from "../../assets/icons/pooling/cb-green.svg";
import { useSelector } from 'react-redux';
import '../../css/commonHeader.css';
import OnBoardingHead from '../onboarding/OnBoardingHead';

const CommonHeader = ({ headerKey, headerTitle, headerSubTitle, type, selectedSurplusValue, selectedDeficitValue,component }) => {
  const { metrics } = useSelector((state) => state.vesselDetails);

    return (
        <div>
            {
            headerKey === "auto_pooling_screen" &&
                <div className="auto-pool-header">
                    <OnBoardingHead 
                        heading="Vessel Auto Pooling"
                        // subheading="Select Vessels to participate in the auto pooling process."
                        type="vessel"
                        />
                </div>
            }
            {
            headerKey === "vessel_details_page" &&
                <div className="vessel-detail-header">
                    <OnBoardingHead 
                        heading="Vessel Details" 
                        // subheading="View the details of the vessels for pooling purpose."
                        type="vessel"
                        />
                </div>
            }
            {
            headerKey === "onboarding_page" &&
                <div className="no-css-header">
                    <OnBoardingHead 
                        heading={headerTitle}
                        subheading={headerSubTitle}
                        type={type}
                        />
                </div>
            }
            {
            headerKey=="pooling_notification" &&
                <div className="pooling-notification-header">
                    <OnBoardingHead 
                        heading={headerTitle}
                        subheading={headerSubTitle}
                        type={type}
                        />
                </div>
            }
            {
            headerKey=="pool_overview" &&
                <div className="no-css-header">
                    <OnBoardingHead 
                        heading={headerTitle}
                        subheading={headerSubTitle}
                        type={type}
                        />
                </div>
            }
            {
            headerKey=="manual_pool" &&
                <div className="manual-pool-header">
                    <OnBoardingHead 
                        heading={headerTitle}
                        subheading={headerSubTitle}
                        type={type}
                        />
                    {component}
                </div>
            }
            {
            headerKey=="estimation" &&
                <div className="estimation-header">
                    <OnBoardingHead 
                        heading={headerTitle}
                        subheading={headerSubTitle}
                        type={type}
                        />
                    {component}
                </div>
            }
        </div>
    );
};

export default CommonHeader;
